import { createSelector } from 'reselect'

const getQuestionData = (state, slideId, questionIndex) => {
	const slide = state.student.slides[slideId]
	return slide.questions[questionIndex]
}

const getStudentData = state => {
	const student = state.student
	return student
}

const getSlideData = (state, slideId) => {
	const student = state.student
	const slide_data = student.slides[slideId]
	return slide_data
}

const getStudentSubmitData = createSelector(
	[ getQuestionData, getStudentData, getSlideData ],
	(questionData, studentData, slideData) => {
		const answers = questionData.selected_answers
		const options = questionData.options
		const submit_answers = options.reduce((accumulator, item) => {
			accumulator[item.key] = answers.indexOf(item.key) !== -1 ? '1' : '0'
			return accumulator
		}, {})

		return {
			answers: submit_answers,
			device_uid: studentData.device_uid,
			headers: studentData.headers,
			editsCount: slideData.editsCount,
		}
	}
)

export default getStudentSubmitData
